import { render, staticRenderFns } from "./WizardToggle.vue?vue&type=template&id=963f63d2&"
import script from "./WizardToggle.vue?vue&type=script&lang=js&"
export * from "./WizardToggle.vue?vue&type=script&lang=js&"
import style0 from "./WizardToggle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports